import { uuid, varchar } from 'drizzle-orm/pg-core/columns';
import { pgTable } from 'drizzle-orm/pg-core/table';
import { index, uniqueIndex } from 'drizzle-orm/pg-core/indexes';
import { foreignKey } from 'drizzle-orm/pg-core/foreign-keys';
import { companies } from './companies';
import { relations } from 'drizzle-orm/relations';
import { InferSelectModel } from 'drizzle-orm/table';
import { users } from './users';
import { commonFields } from './common-fields';

export enum CompanyUserRole {
  Admin = 'Admin',

  // Special purpose roles for Bolago employees
  Butler = 'Butler',
  SupportAgent = 'SupportAgent',
}

export type CompanyUser = InferSelectModel<typeof companyUsers>;

export const companyUsers = pgTable(
  'company_users',
  {
    ...commonFields,
    userId: uuid('user_id').notNull(),
    companyId: uuid('company_id').notNull(),
    role: varchar().notNull().$type<CompanyUserRole>().notNull(),
  },
  table => {
    return [
      {
        idxUserCompaniesCompanyId: index('idx_user_companies_company_id').using(
          'btree',
          table.companyId.asc().nullsLast(),
        ),
        idxUserCompaniesUserId: index('idx_user_companies_user_id').using('btree', table.userId.asc().nullsLast()),
        indexUserCompaniesOnUserIdAndCompanyId: uniqueIndex('index_user_companies_on_user_id_and_company_id').using(
          'btree',
          table.userId.asc().nullsLast(),
          table.companyId.asc().nullsLast(),
        ),
        fkRails8C4Dddfe20: foreignKey({
          columns: [table.userId],
          foreignColumns: [users.id],
          name: 'fk_rails_8c4dddfe20',
        }),
        fkRailsF5Aed666F1: foreignKey({
          columns: [table.companyId],
          foreignColumns: [companies.id],
          name: 'fk_rails_f5aed666f1',
        }),
      },
    ];
  },
);

export const companyUsersRelations = relations(companyUsers, ({ one }) => ({
  user: one(users, {
    fields: [companyUsers.userId],
    references: [users.id],
  }),
  company: one(companies, {
    fields: [companyUsers.companyId],
    references: [companies.id],
  }),
}));
